import React from "react";

const ShiftWeeklyOffRulesAssignments = () => {
    return <div>ShiftWeeklyOffRulesAssignments</div>;
}

export default ShiftWeeklyOffRulesAssignments;